import styled from "@emotion/styled";
import {colors} from "../../config/StyleGuide";

export const BlackMarker = styled.div`
  height: 8px;
  width: 98px;
  background-color: ${colors.warmGraphite};
`;
